import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';
import {Card, Grid, Input} from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {linesOptions} from '../../../common/dictionaries/kpis';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import PriceSection from './priceSection';
import LineSection from './lineSection';
import LinesInfoTable from './table';
import './cpd.scss';

class CpdKpi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'startDateFilter': moment().set('date', 1).format(noTimeZoneShortISODate),
      'endDateFilter': moment().format(noTimeZoneShortISODate),
      'filterType': {
        'received': 'zone',
        'backOrder': 'zone',
        'dispatched': 'dealer',
      },
      'filterTypeLabel': {
        'received': 'Zona',
        'backOrder': 'Zona',
        'dispatched': 'Concesionario',
      },
    };
    this.changeStartDate = this.changeStartDate.bind(this);
    this.changeEndDate = this.changeEndDate.bind(this);
    this.setFilterType = this.setFilterType.bind(this);
  }

  componentDidMount() {
    this.props.clearLinesInfo();
    this.props.fetchInventoryStatus();
    this.props.fetchInventoryStatusDetail();
    this.getLinesInfo();
  }

  componentWillUnmount() {
    this.props.clearLinesInfo();
  }

  getLinesInfo() {
    const {startDateFilter, endDateFilter} = this.state;
    this.props.fetchLinesInfo(startDateFilter, endDateFilter);
  }

  changeStartDate(date) {
    this.props.clearUrlLinesFile();
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);

    const {startDateFilter, endDateFilter} = this.state;
    if (dateFormatted !== startDateFilter) {
      this.setState({'startDateFilter': dateFormatted}, () =>
        this.getLinesInfo()
      );
    }
    if (!endDateFilter) {
      this.setState({'endDateFilter': dateFormatted}, () => this.getLinesInfo());
    }
  }

  changeEndDate(date) {
    this.props.clearUrlLinesFile();
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);
    if (dateFormatted === this.state.endDateFilter) {
      return;
    }
    this.setState({'endDateFilter': dateFormatted}, () => this.getLinesInfo());
  }

  setFilterType(lineType, filterType, filterLabel) {
    const newFiltersTypes = {...this.state.filterType};
    newFiltersTypes[lineType] = filterType;

    const newLabels = {...this.state.filterTypeLabel};
    newLabels[lineType] = filterLabel;

    this.setState({
      'filterType': newFiltersTypes,
      'filterTypeLabel': newLabels,
    });
  }

  renderFilterDates() {
    const {startDateFilter, endDateFilter} = this.state;
    return (
      <Grid textAlign='left'>
        <Grid.Row>
          <Grid.Column width={3} className='label'>
            <h4>Fecha Inicial</h4>
          </Grid.Column>
          <Grid.Column width={5}>
            <DatePicker
              customInput={<Input icon='calendar' size='small' />}
              dateFormat={dateFormatPicker}
              selected={
                startDateFilter ?
                  moment(startDateFilter, noTimeZoneShortISODate).toDate() :
                  null
              }
              onChange={this.changeStartDate}
              locale='es'
              placeholderText='Fecha Inicio'
            />
          </Grid.Column>
          <Grid.Column width={3} className='label'>
            <h4>Fecha Final</h4>
          </Grid.Column>
          <Grid.Column width={5}>
            <DatePicker
              customInput={<Input icon='calendar' size='small' />}
              dateFormat={dateFormatPicker}
              selected={
                endDateFilter ?
                  moment(endDateFilter, noTimeZoneShortISODate).toDate() :
                  null
              }
              onChange={this.changeEndDate}
              locale='es'
              placeholderText='Fecha Fin'
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  render() {
    const {startDateFilter, endDateFilter, filterType, filterTypeLabel} = this.state;
    const {lineInfo, seePriceSection} = this.props;

    return (
      <div className='kpi-cpd'>
        {seePriceSection && <PriceSection />}
        <Card raised fluid>
          <div className='title-bar'>
            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row>
                  <Grid.Column width={4}>
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <div className='gray-bg dates-filters-container'>
                      {this.renderFilterDates()}
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>

        <Grid columns={3}>
          <Grid.Row>
            <Grid.Column>
              <LineSection initialDate={startDateFilter} finalDate={endDateFilter}
                lineLabel={linesOptions.received} lineType='received'
                numberLines={lineInfo.receivedLines} average={lineInfo.averageReceivedLines}
                onFilterChange={this.setFilterType}
              />
            </Grid.Column>

            <Grid.Column>
              <LineSection initialDate={startDateFilter} finalDate={endDateFilter}
                lineLabel={linesOptions.backOrder} lineType='backOrder'
                numberLines={lineInfo.backOrderLines} average={lineInfo.averageBackOrdersLines}
                onFilterChange={this.setFilterType} />
            </Grid.Column>

            <Grid.Column>
              <LineSection initialDate={startDateFilter} finalDate={endDateFilter}
                lineLabel={linesOptions.dispatched} lineType='dispatched'
                numberLines={lineInfo.dispatchedLines} average={lineInfo.averageDispatchedLines}
                onFilterChange={this.setFilterType} />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid columns={3}>
          <Grid.Row>
            <Grid.Column>
              <LinesInfoTable initialDate={startDateFilter} finalDate={endDateFilter}
                filterType={filterType.received} filterTypeLabel={filterTypeLabel.received}
                lineLabel={linesOptions.received} lineType='received' />
            </Grid.Column>

            <Grid.Column>
              <LinesInfoTable initialDate={startDateFilter} finalDate={endDateFilter}
                filterType={filterType.backOrder} filterTypeLabel={filterTypeLabel.backOrder}
                lineLabel={linesOptions.backOrder} lineType='backOrder' />
            </Grid.Column>

            <Grid.Column>
              <LinesInfoTable initialDate={startDateFilter} finalDate={endDateFilter}
                filterType={filterType.dispatched} filterTypeLabel={filterTypeLabel.dispatched}
                lineLabel={linesOptions.dispatched} lineType='dispatched' />
            </Grid.Column>

          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingInventoryStatus': state.cpd.loadingInventoryStatus,
    'inventoryStatus': state.cpd.inventoryStatus,
    'loadingAmountDetail': state.cpd.loadingAmountDetail,
    'amountDetail': state.cpd.amountDetail,
    'loadingLinesInfo': state.cpd.loadingLinesInfo,
    'lineInfo': state.cpd.lineInfo,
    'permissions': state.session.permissions,
  };
};

const {
  clearLinesInfo,
  clearUrlLinesFile,
  fetchInventoryStatus,
  fetchInventoryStatusDetail,
  fetchLinesInfo,
} = Actions;

export default connect(mapStateToProps, {
  clearLinesInfo,
  clearUrlLinesFile,
  fetchInventoryStatus,
  fetchInventoryStatusDetail,
  fetchLinesInfo,
})(CpdKpi);
